import "@/App.css";
import "@/styles/upgrade.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SiteLayout from "./components/site/SiteLayout";
import AdminRoute from "./pages/admin/AdminRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminRoute />} />
        <Route path="*" element={<SiteLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
